import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import { usePaymentDialog } from '../context/PaymentDialogProvider'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './PaymentErrorBanner.module.scss'

export const PaymentErrorBanner = () => {
  const { t } = useTranslation(['Errors', 'Common'])
  const { dialogState } = usePaymentDialog()

  if (!dialogState.paymentError) {
    return null
  }

  const { message, severity } = dialogState.paymentError

  return (
    <KibTopLevelAlert
      className={styles.paymentErrorBanner}
      heading={t('Errors:DEFAULT_ERROR')}
      severity={severity}
    >
      {message}
    </KibTopLevelAlert>
  )
}
